var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgPaper = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42 28L28 41.9907L2.338 42C1.7208 42.0025 1.12786 41.7598 0.689467 41.3254C0.251073 40.8909 0.00308722 40.3002 0 39.683V2.317C0 1.03833 1.03833 0 2.317 0H39.683C40.9617 0 42 1.064 42 2.338V28ZM37.3333 4.66667H4.66667V37.3333H23.3333V25.6667C23.3334 25.0952 23.5432 24.5435 23.923 24.1165C24.3028 23.6894 24.8261 23.4165 25.3937 23.3497L25.6667 23.3333L37.3333 23.331V4.66667ZM35.399 27.9977L28 28V35.3943L35.399 27.9977Z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPaper, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/paper.b18c2733.svg";
export { ForwardRef as ReactComponent };